import { Row, Col, Card, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CountUp from 'react-countup';

const cardConfig = [
  {
    key: 'urgent',
    filterValue: 'URGENT',
    title: 'Urgent',
    icon: 'exclamation-triangle',
    color: 'danger',
    bgColor: 'bg-soft-danger',
    description: 'Needs immediate action'
  },
  {
    key: 'high',
    filterValue: 'HIGH',
    title: 'High Priority',
    icon: 'arrow-up',
    color: 'warning',
    bgColor: 'bg-soft-warning',
    description: 'Address this week'
  },
  {
    key: 'medium',
    filterValue: 'MEDIUM',
    title: 'Medium',
    icon: 'minus',
    color: 'info',
    bgColor: 'bg-soft-info',
    description: 'Review when possible'
  },
  {
    key: 'ok',
    filterValue: 'OK',
    title: 'OK',
    icon: 'check',
    color: 'success',
    bgColor: 'bg-soft-success',
    description: 'No action needed'
  }
];

export default function SummaryCards({ counts = {}, loading = false, activePriority = null, onPriorityClick }) {
  const handleCardClick = (filterValue) => {
    if (onPriorityClick) {
      // Toggle off if clicking the same priority, otherwise set it
      onPriorityClick(activePriority === filterValue ? 'all' : filterValue);
    }
  };

  return (
    <Row className="g-3 mb-3">
      {cardConfig.map(config => {
        const isActive = activePriority === config.filterValue;
        return (
          <Col key={config.key} md={6} xl={3}>
            <Card
              className={`h-100 ${config.bgColor} summary-card-clickable ${isActive ? 'summary-card-active' : ''}`}
              onClick={() => handleCardClick(config.filterValue)}
              style={{ cursor: 'pointer', transition: 'all 0.2s ease' }}
            >
              <Card.Body className="d-flex align-items-center">
                <div className={`rounded-circle bg-${config.color} d-flex align-items-center justify-content-center me-3`}
                     style={{ width: '48px', height: '48px' }}>
                  <FontAwesomeIcon
                    icon={config.icon}
                    className="text-white fs-5"
                  />
                </div>
                <div className="flex-1">
                  <h6 className="mb-0 text-700">
                    {config.title}
                    {isActive && (
                      <FontAwesomeIcon icon="filter" className="ms-2 text-primary" style={{ fontSize: '0.7rem' }} />
                    )}
                  </h6>
                  <h3 className={`mb-0 text-${config.color}`}>
                    {loading ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      <CountUp
                        end={counts[config.key] || 0}
                        duration={1}
                        separator=","
                      />
                    )}
                  </h3>
                  <p className="mb-0 fs--1 text-500">{config.description}</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
        );
      })}
    </Row>
  );
}
